import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Tema por defecto — evita flash de contenido sin clase
if (!document.documentElement.classList.contains('dark') &&
    !document.documentElement.classList.contains('light')) {
  const tema = localStorage.getItem('cf-theme') || 'dark';
  document.documentElement.classList.add(tema);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
